import * as React from 'react'
import TopBarProgress from 'react-topbar-progress-indicator'

interface Props {
  role?: string
}

export const TopBarLoading: React.FC<Props> = ({ role }) =>
  TopBarProgress ? <TopBarProgress /> : <div role={role || 'top-bar-loading'} />
